import React from "react";

export default function PageShell({ children, hasBottomNav = true }) {
  return (
    <div className="min-h-screen bg-[#09090B] text-foreground">
      <div className={`mx-auto max-w-md ${hasBottomNav ? "pb-44" : ""}`}>
        {children}
      </div>
    </div>
  );
}
